class HoverDropdown {
    constructor(element) {
        this.element = element
        this.content = $(this.element).find('.js-hover-dropdown-content')
        this.button = $(this.element).find('.js-hover-dropdown-button')
        this.initListeners()
    }

    initListeners() {
        $(this.element).on('mouseenter', this.openDropdown.bind(this))
        $(this.element).on('mouseleave', this.closeDropdown.bind(this))
    }

    openDropdown() {
        this.button.addClass('active')
        this.content.slideDown()
    }

    closeDropdown() {
        this.button.removeClass('active')
        this.content.slideUp(200)
    }
}

const isHoverDevice = window.matchMedia(
    '(hover: hover) and (pointer: fine)'
)

if (isHoverDevice.matches) {
    $('.js-hover-dropdown').each((index, item) => {
        new HoverDropdown(item)
    })
}